$(document).ready(function () {
    const profileText = {
        confirmDeleteLogo: 'Do you want to delete the logo?',
        addMva: 'Add VAT',
        removeMva: 'Remove VAT',
        addForetaksregisteret: 'Add Foretaksregisteret',
        removeForetaksregisteret: 'Remove Foretaksregisteret',
        savedTitle: 'Saved!',
        errorTitle: 'Error!',
        deletedTitle: 'Deleted!',
        saveSuccess: 'The company profile has been updated.',
        saveRefreshError: 'Could not update the profile page after saving.',
        saveError: 'Could not save profile!',
        logoDeleted: 'The logo has been deleted.',
        logoDeleteError: 'Could not delete logo!',
        mvaAdded: 'VAT has been added to the organization number.',
        mvaRemoved: 'VAT has been removed from the organization number.',
        mvaAddError: 'Could not add VAT to the organization number!',
        mvaRemoveError: 'Could not remove VAT from the organization number!',
        foretaksregisteretAdded: 'Foretaksregisteret has been added to the organization number.',
        foretaksregisteretRemoved: 'Foretaksregisteret has been removed from the organization number.',
        foretaksregisteretAddError: 'Could not add Foretaksregisteret to the organization number!',
        foretaksregisteretRemoveError: 'Could not remove Foretaksregisteret from the organization number!'
    };
    const CONFIRM_MESSAGE_DELETE_LOGO = profileText.confirmDeleteLogo;
    let ajaxPath = '/action/profile';
    let ajaxLockActive = false;

    let profileFormSelector = 'form#profile_form';
    let profileRouteViewSelector = '#profile-route-view';
    let alertSelector = 'div#alert_message';

    const primaryButtonClasses = 'transition duration-200 border shadow-sm inline-flex w-full items-center justify-center rounded-md px-3 py-2 text-sm font-medium cursor-pointer focus:ring-4 focus:ring-primary focus:ring-opacity-20 focus-visible:outline-none bg-primary border-primary text-white hover:bg-primary/90 hover:border-primary/90 disabled:opacity-70 disabled:cursor-not-allowed [&:hover:not(:disabled)]:bg-opacity-90 [&:hover:not(:disabled)]:border-opacity-90 sm:w-auto';
    const dangerButtonClasses = 'transition duration-200 border shadow-sm inline-flex w-full items-center justify-center rounded-md px-3 py-2 text-sm font-medium cursor-pointer focus:ring-4 focus:ring-primary focus:ring-opacity-20 focus-visible:outline-none bg-danger border-danger text-white hover:bg-danger/90 hover:border-danger/90 disabled:opacity-70 disabled:cursor-not-allowed [&:hover:not(:disabled)]:bg-opacity-90 [&:hover:not(:disabled)]:border-opacity-90 sm:w-auto';
    const btnAddMvaHtml = '<button type="button" class="' + primaryButtonClasses + '" id="add_mva_button">' + profileText.addMva + '</button>';
    const btnDeleteMvaHtml = '<button type="button" class="' + dangerButtonClasses + '" id="delete_mva_button">' + profileText.removeMva + '</button>';
    const btnAddForetaksregisteretHtml = '<button type="button" class="' + primaryButtonClasses + '" id="add_foretaksregisteret_button">' + profileText.addForetaksregisteret + '</button>';
    const btnDeleteForetaksregisteretHtml = '<button type="button" class="' + dangerButtonClasses + '" id="delete_foretaksregisteret_button">' + profileText.removeForetaksregisteret + '</button>';

    $(document).on('click', profileFormSelector + ' [name="lagreProfil"]', function (event) {
        event.preventDefault();

        let saveButton = $(this);
        let profileForm = saveButton.closest(profileFormSelector);

        if (profileForm.length === 0) {
            return true;
        }

        // Only route-based profile page should be saved with this AJAX endpoint.
        if (profileForm.closest(profileRouteViewSelector).length === 0) {
            return true;
        }

        if (ajaxLockActive) {
            event.preventDefault();
            return false;
        }

        event.preventDefault();
        ajaxLockActive = true;

        saveButton.prop('disabled', true);

        let formData = new FormData(profileForm.get(0));

        $.ajax({
            type: 'POST',
            url: ajaxPath + '/save',
            data: formData,
            dataType: 'json',
            processData: false,
            contentType: false
        }).success(function (data) {
            if (data && data.success) {
                displayTailwindAlert(profileText.savedTitle, profileText.saveSuccess, alertSelector, 'success', 'replace');
                window.scrollTo(0, 0);
                setTimeout(function () {
                    window.location.reload();
                }, 900);
                return;
            }
            displayTailwindAlert(profileText.errorTitle, profileText.saveRefreshError, alertSelector, 'error', 'replace');
        }).error(function () {
            displayTailwindAlert(profileText.errorTitle, profileText.saveError, alertSelector, 'error', 'replace');
        }).always(function () {
            ajaxLockActive = false;
            saveButton.prop('disabled', false);
        });

        return false;
    });

    $(document).on('click', profileFormSelector + ' #delete_logo_button', function () {
        // Check that an operation is not already in process
        if (ajaxLockActive) {
            return false;
        }

        if (!confirm(CONFIRM_MESSAGE_DELETE_LOGO)) {
            return;
        }

        ajaxLockActive = true;

        $.ajax({
            type: 'DELETE',
            url: ajaxPath + '/delete-logo',
            data: {},
            dataType: 'json'
        }).success(function () {
            // Remove image from DOM
            $(profileFormSelector + ' div#logo_image_wrapper').html('');
            displayTailwindAlert(profileText.deletedTitle, profileText.logoDeleted, alertSelector, 'success', 'replace');
        }).error(function () {
            displayTailwindAlert(profileText.errorTitle, profileText.logoDeleteError, alertSelector, 'error', 'replace');
        }).always(function () {
            ajaxLockActive = false;
        });
        return false;
    });

    $(document).on('click', profileFormSelector + ' #add_mva_button', function () {
        if (ajaxLockActive) {
            return false;
        }

        ajaxLockActive = true;

        $.ajax({
            type: 'POST',
            url: ajaxPath + '/add-mva',
            dataType: 'json'
        }).success(function (data) {
            if(data.hasOwnProperty('orgnr')) {
                updateOrgnrFields(data.orgnr);
            }
            if(data.changed == true) {
                $(document).find('#mva_btn_wrapper').html(btnDeleteMvaHtml);
                displayTailwindAlert(profileText.savedTitle, profileText.mvaAdded, alertSelector, 'success', 'replace');
            }
        }).error(function () {
            displayTailwindAlert(profileText.errorTitle, profileText.mvaAddError, alertSelector, 'error', 'replace');
        }).always(function () {
            ajaxLockActive = false;
        });
        return false;
    });

    $(document).on('click', profileFormSelector + ' #delete_mva_button', function () {
        if (ajaxLockActive) {
            return false;
        }

        ajaxLockActive = true;

        $.ajax({
            type: 'POST',
            url: ajaxPath + '/delete-mva',
            dataType: 'json'
        }).success(function (data) {
            if(data.hasOwnProperty('orgnr')) {
                updateOrgnrFields(data.orgnr);
            }
            if(data.changed == true) {
                $(document).find('#mva_btn_wrapper').html(btnAddMvaHtml);
                displayTailwindAlert(profileText.savedTitle, profileText.mvaRemoved, alertSelector, 'success', 'replace');
            }
        }).error(function (err) {
            displayTailwindAlert(profileText.errorTitle, profileText.mvaRemoveError, alertSelector, 'error', 'replace');
        }).always(function () {
            ajaxLockActive = false;
        });
        return false;
    });

    $(document).on('click', profileFormSelector + ' #add_foretaksregisteret_button', function () {
        if (ajaxLockActive) {
            return false;
        }

        ajaxLockActive = true;

        $.ajax({
            type: 'POST',
            url: ajaxPath + '/add-foretaksregisteret',
            dataType: 'json'
        }).success(function (data) {
            if(data.hasOwnProperty('orgnr')) {
                updateOrgnrFields(data.orgnr);
            }
            if(data.changed == true) {
                $(document).find('#foretaksregisteret_btn_wrapper').html(btnDeleteForetaksregisteretHtml);
                displayTailwindAlert(profileText.savedTitle, profileText.foretaksregisteretAdded, alertSelector, 'success', 'replace');
            }
        }).error(function (err) {
            displayTailwindAlert(profileText.errorTitle, profileText.foretaksregisteretAddError, alertSelector, 'error', 'replace');
        }).always(function () {
            ajaxLockActive = false;
        });
        return false;
    });

    $(document).on('click', profileFormSelector + ' #delete_foretaksregisteret_button', function () {
        if (ajaxLockActive) {
            return false;
        }

        ajaxLockActive = true;

        $.ajax({
            type: 'POST',
            url: ajaxPath + '/delete-foretaksregisteret',
            dataType: 'json'
        }).success(function (data) {
            if(data.hasOwnProperty('orgnr')) {
                updateOrgnrFields(data.orgnr);
            }
            if(data.changed == true) {
                $(document).find('#foretaksregisteret_btn_wrapper').html(btnAddForetaksregisteretHtml);
                displayTailwindAlert(profileText.savedTitle, profileText.foretaksregisteretRemoved, alertSelector, 'success', 'replace');
            }
        }).error(function (err) {
            displayTailwindAlert(profileText.errorTitle, profileText.foretaksregisteretRemoveError, alertSelector, 'error', 'replace');
        }).always(function () {
            ajaxLockActive = false;
        });
        return false;
    });

    function updateOrgnrFields(orgnr) {
        $(document).find('#orgnr_input').val(orgnr);
        $(document).find('#orgnr_text').text(orgnr);
    }
});
